"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyTypeMap = exports.JourneyType = void 0;
exports.journeyIdFrom = journeyIdFrom;
var JourneyType;
(function (JourneyType) {
    JourneyType["ANNUAL_HOME"] = "ANNUAL_HOME";
    JourneyType["ANNUAL_MOTOR"] = "ANNUAL_MOTOR";
})(JourneyType || (exports.JourneyType = JourneyType = {}));
exports.JourneyTypeMap = new Map([
    [JourneyType.ANNUAL_HOME, [
            "Annual_Home_NB_Journey",
            "Annual_Home_MTA_Journey",
            "Annual_Home_Journey_Policy_Cancellation",
            "Annual_Home_Change_Address",
            "Annual_Home_Forced_Policy_Cancellation",
            "Annual_Home_Journey_Edit_Renewal_Proposal",
            "Motor_Support_Portal_Cancel_Annual_Home",
            "Motor_Support_Portal_Cancel_Subscription_Renters",
            "Motor_Support_Portal_Edit_Customer_Address",
            "Motor_Support_Portal_Home_MTA",
            "Annual_Home_Support_Portal_Change_Address",
            "Annual_Home_Support_Portal_Forced_Cancellation"
        ]],
    [JourneyType.ANNUAL_MOTOR, [
            "Motor_Journey",
            "Motor_Journey_Edit_Car_Details",
            "Motor_Journey_Replace_Car",
            "Motor_Journey_Policy_Cancelation",
            "Motor_Journey_Add_Additional_Driver",
            "Motor_Journey_Change_Address",
            "Motor_Journey_Edit_Driver_Details",
            "Motor_Journey_Remove_Driver",
            "Motor_Journey_Payment_Day",
            "Motor_Journey_Forced_Policy_Cancelation",
            "Motor_Journey_Pay_Off_Balance",
            "Motor_Journey_Edit_Registration_Number",
            "Motor_Journey_Edit_Renewal_Proposal",
            "Motor_Journey_Post_Renewal_Claim_Impact",
            "Motor_Journey_Edit_Policy_Start_Date",
            "Motor_Edit_Car_Journey",
            "Motor_Support_Portal_Cancel_Annual_Motor",
            "Motor_Support_Portal_Cancel_Subscription_Motor",
            "Motor_Support_Portal_Edit_MTA_Limits",
            "Motor_Support_Portal_Edit_Named_Driver_Annual_Motor",
            "Motor_Support_Portal_Annual_Edit_Optional_Extras",
            "Motor_Support_Portal_Annual_Replace_Car",
            "Motor_Support_Portal_Add_Additional_Driver"
        ]]
]);
function journeyIdFrom(type, journeyId) {
    var journeyTypes = exports.JourneyTypeMap.get(type);
    return journeyTypes ? journeyTypes.includes(journeyId) : false;
}
//# sourceMappingURL=JourneyType.js.map